import { httpClient } from 'app/api/http/http-client';
import { useQuery } from 'react-query';

const refreshToken = localStorage.getItem('refreshToken');

const accountService = {
  getAccountData: async () => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/account_list');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'accounts-card?type=accounts';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useGetAccount = (dataTransfer?: any) => {
  const {
    isFetching: isFetchingGetDataAccount,
    isLoading: isLoadingGetDataAccount,
    data: dataGetAccount,
    refetch: refetchGetDataAccount,
  } = useQuery(['getAccountData'], accountService.getAccountData, {
    cacheTime: 0,
    enabled: false,
  });

  return { isFetchingGetDataAccount, isLoadingGetDataAccount, dataGetAccount, refetchGetDataAccount };
};
